module.exports = __webpack_public_path__ + "a3f3974165de1f398e42e9deb41f34c2.pdf";